class jfMessagesController {
	constructor($scope, $state, $window, JFrogEventBus) {

		this.$state = $state;
		this.$window = $window;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.JFrogEventBus = JFrogEventBus;

        this.msgs = [];


		angular.element(this.$window).on('resize', this.handleSizing.bind(this));
		$scope.$on('$destroy', () => {
			angular.element(this.$window).off('resize');
		});

		setTimeout(() => {
			this.handleSizing();

			$(document).on('mouseenter', '.message-text a', () => {
				$('.message-container').addClass('pause-animation')
			});
			$(document).on('mouseleave', '.message-text a', () => {
				$('.message-container').removeClass('pause-animation')
			});
		}, 300);


        this.JFrogEventBus.register(this.EVENTS.CANT_ACCESS_MISSION_CONTROL, () => {
			if (this.msgs.length===0){
                this.msgs.push({message:'Access to Mission Control denied. Please verify that the Distribution service is configured correctly in Mission Control.',type:'warning'});
			}

        })




        }


	handleSizing() {
		if ($('.constant-message.system').length) {
			let maxMessageSize = this.$window.innerWidth - $('.constant-message.system .message-title').width() - ($('.constant-message.system .message-container').offset().left * 2) - 10,
				msgText = $('.constant-message.system .message-text');

			if (msgText.find('span').width() > maxMessageSize) {
				msgText.css('width', maxMessageSize).addClass('marqueed');
			} else {
				msgText.css('width', 'auto').removeClass('marqueed');
			}
		}
	}
}

jfMessagesController.$inject = ['$scope', '$state', '$window', 'JFrogEventBus'];

export default function jfMessages() {
	return {
		controller: jfMessagesController,
		controllerAs: 'jfMessages',
		bindToController: true,
		templateUrl: 'directives/jf_messages/jf_messages.html',

	};
}

jfMessages.META = {
    name: 'distributionMessages'
};



// WEBPACK FOOTER //
// ./modules/distribution/directives/jf_messages/jf_messages.js